import React, {FC, useEffect, useState} from 'react';
import GatewayService from "../service/GatewayService";
import {ClosingPrice} from "../models/ClosingPrice";
import {CheckboxComponent} from "./util/CheckboxComponent";
import TickManager from "../service/TickManager";
import AppUtil from "../util/AppUtil";
import {DropDownCompString, getKeyVal} from "./util/DropDownComp";
import {useClients} from "../context/ClientsContext";

// @ts-ignore
// import faker from 'faker';


const EquityFeedComponent : FC<ClosingPrice> = (feed: ClosingPrice) => {
    return <tr>
        <td>{feed.symbol}</td>
        <td>{feed.lastPrice}</td>
        <td>{AppUtil.getRoundedOff(feed.expectedClosing)}</td>
    </tr>
}

const EquityWatchComponent:FC = () => {
    const [closings, setClosings] = useState<Array<ClosingPrice>>([]);
    const [positions, setPositions] = useState<Set<string>>(new Set())
    const [futures, setFutures] = useState<Set<string>>(new Set())
    const [onlyOpenPositions, setonlyOpenPositions] = useState(false)
    const [clientId, setClientId] = useState("")
    const { clients } = useClients();

    console.log(`positions are ${positions}`)
    useEffect(() => {
        if (clients && clients.length > 0 && clientId === "") {
            setClientId(clients[0]);
        }
    }, [clients, clientId]);

    useEffect(()=>{
        if (!clientId) return;
        let id = setInterval(()=>{
            GatewayService.getClosings("all").then(setClosings)
            GatewayService.getRawPositions(clientId)
                .then(it => it.filter(it => !!TickManager.getOption(it.tradingsymbol)))
                .then(it=> {
                    let pos = it.map(it => TickManager.getOption(it.tradingsymbol).genInfo)
                    let posSet = new Set<string>()
                    pos.forEach(it=>posSet.add(it.name))
                    setPositions(posSet)
                    let futures = new Set<string>()
                    pos.forEach(it=>{
                        const fut = TickManager.getFuture(it.tradingsymbol)
                        if (fut) futures.add(fut.genInfo.tradingsymbol)
                    })
                    setFutures(futures)
                })
        }, 1000)
        return ()=>clearInterval(id)
    }, [clientId])

    function getPrices() {
        return closings.filter(it=>(!onlyOpenPositions || positions.has(it.symbol) || futures.has(it.symbol)) )
    }

    function getClients() {
        return clients || [];
    }

    return<>
        <CheckboxComponent text={"positions"} actual={onlyOpenPositions} val={onlyOpenPositions} set={setonlyOpenPositions}/>
        <DropDownCompString text={"select client"} actual={clientId} arr={getKeyVal(getClients())} set={setClientId}/>

        <table>
            <thead>
            <tr>
                <th>symbol</th>
                <th>last price</th>
                <th>closing</th>
            </tr>
            </thead>
            <tbody>
            {getPrices()
                .map(feed => <EquityFeedComponent
                // key = {feed.sgb.tradingsymbol}
                {...feed}/>)}
            </tbody>
        </table>    </>
}

export default EquityWatchComponent
